 
  document.addEventListener('keydown', function(e) {
    // Only run if the Tab key is pressed
    if (e.key !== 'Tab') return;

    // 1. Find the currently active sidebar link and panel
    const activeSidebarLink = document.querySelector('.sub-menu.active > a, .sub-menu.active a');
    const activePanel = document.querySelector('.sub-menu-item.is-active');
    
    if (!activeSidebarLink || !activePanel) return;

    // Get all focusable links inside the active panel
    const panelLinks = activePanel.querySelectorAll('a[href], button');
    if (panelLinks.length === 0) return;

    const firstPanelLink = panelLinks[0];
    const lastPanelLink = panelLinks[panelLinks.length - 1];
    const currentFocus = document.activeElement;

    // SCENARIO A: Tabbing FORWARD from the sidebar link -> Jump INTO the panel
    if (currentFocus === activeSidebarLink && !e.shiftKey) {
      e.preventDefault();
      firstPanelLink.focus();
      return;
    }

    // SCENARIO B: Shift+Tab from the FIRST link in the panel -> Jump BACK to sidebar
    if (currentFocus === firstPanelLink && e.shiftKey) {
      e.preventDefault();
      activeSidebarLink.focus();
      return;
    }

    // SCENARIO C: Tabbing FORWARD from the LAST link in the panel -> Jump to NEXT sidebar link
    if (currentFocus === lastPanelLink && !e.shiftKey) {
      e.preventDefault();
      
      // Find the next sidebar link in the list
      const currentSidebarItem = activeSidebarLink.closest('.sub-menu');
      let nextSibling = currentSidebarItem.nextElementSibling;
      
      // Skip any non-sidebar elements
      while (nextSibling && !nextSibling.classList.contains('sub-menu')) {
        nextSibling = nextSibling.nextElementSibling;
      }
      
      if (nextSibling) {
        const nextLink = nextSibling.querySelector('a');
        if (nextLink) nextLink.focus();
      }
    }
  });
 